import { css } from 'styled-components';

const base = css`
  display: inline-block;
  padding: 0;
  font-size: 0;
  border: none;
  cursor: pointer;
  outline: none;
  text-decoration: none;
  background-color: transparent;
  transition: opacity 135ms ease-in-out, background-color 135ms ease-in-out;
`;

export default base;
